export default "__VITE_ASSET__746eff99__"